module.exports = __webpack_public_path__ + "static/media/edit-files.d24ec805.svg";